<template>
  <div>
    <b-card-title class="mb-2">
      {{ $t('settings.coordinates.conversion.title') }}
    </b-card-title>
    <b-card-text class="mb-3 text-muted">
      {{ $t('settings.coordinates.conversion.description') }}
    </b-card-text>

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- Degrees to Radians -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.conversion.degrees_to_radians')"
            label-for="degrees-to-radians"
            :description="$t('settings.coordinates.conversion.degrees_to_radians_desc')"
          >
            <b-form-input
              id="degrees-to-radians"
              v-model.number="form.degrees_to_radians"
              type="number"
              step="0.0000000000001"
              required
            />
            <small class="text-muted">{{ $t('settings.coordinates.conversion.formula') }}: π/180</small>
          </b-form-group>
        </b-col>

        <!-- Radians to Degrees -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.conversion.radians_to_degrees')"
            label-for="radians-to-degrees"
            :description="$t('settings.coordinates.conversion.radians_to_degrees_desc')"
          >
            <b-form-input
              id="radians-to-degrees"
              v-model.number="form.radians_to_degrees"
              type="number"
              step="0.0000000000001"
              required
            />
            <small class="text-muted">{{ $t('settings.coordinates.conversion.formula') }}: 180/π</small>
          </b-form-group>
        </b-col>

        <!-- Meters to Feet -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.conversion.meters_to_feet')"
            label-for="meters-to-feet"
            :description="$t('settings.coordinates.conversion.meters_to_feet_desc')"
          >
            <b-form-input
              id="meters-to-feet"
              v-model.number="form.meters_to_feet"
              type="number"
              step="0.000001"
              required
            />
            <small class="text-muted">{{ $t('settings.coordinates.conversion.standard') }}: 3.28084</small>
          </b-form-group>
        </b-col>

        <!-- Feet to Meters -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.conversion.feet_to_meters')"
            label-for="feet-to-meters"
            :description="$t('settings.coordinates.conversion.feet_to_meters_desc')"
          >
            <b-form-input
              id="feet-to-meters"
              v-model.number="form.feet_to_meters"
              type="number"
              step="0.000001"
              required
            />
            <small class="text-muted">{{ $t('settings.coordinates.conversion.standard') }}: 0.3048</small>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Actions -->
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="loading"
          @click="resetForm"
        >
          {{ $t('common.reset') }}
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-50"
          />
          {{ $t('common.save') }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'ConversionFactorsForm',
  components: {
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  props: {
    factors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        degrees_to_radians: 0.0174532925199433,
        radians_to_degrees: 57.2957795130823,
        meters_to_feet: 3.28084,
        feet_to_meters: 0.3048,
      },
    }
  },
  watch: {
    factors: {
      immediate: true,
      deep: true,
      handler(newFactors) {
        if (newFactors && Object.keys(newFactors).length > 0) {
          this.form = { ...this.form, ...newFactors }
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('save', { ...this.form })
    },
    resetForm() {
      if (this.factors && Object.keys(this.factors).length > 0) {
        this.form = { ...this.factors }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mr-50 {
  margin-right: 0.5rem;
}
</style>
